<input type="text" value="" />


// WEBPACK FOOTER //
// ./node_modules/ng2-ion-range-slider/lib/ion-range-slider.component.d.ts.IonRangeSliderComponent.html